import css from '@styled-system/css';
import merge from 'deepmerge';

var sx = function sx(props) {
  return css(props.sx);
};

export default sx;
export { merge };